import { ApolloClient } from '@apollo/client'
import { isLoggedInVar } from '../apollo'
import { removePerformanceStatsFilters } from './hooks/useLocalStorage'

const tokenName = 'token'
const originalTokenName = 'token-original'
const impersonationTokenName = 'token-impersonation'

export const getUserToken = (): string | null => localStorage.getItem(tokenName)
export const getOriginalToken = (): string | null => localStorage.getItem(originalTokenName)
export const getImpersonationToken = (): string | null => localStorage.getItem(impersonationTokenName)
export const isImpersonating = (): boolean => !!getImpersonationToken()
export const hasToken = (): boolean => !!getUserToken()

export const saveToken = (token: string): void => {
  localStorage.setItem(tokenName, token)
  isLoggedInVar(true)
}

export const startImpersonationSession = (originalToken: string, impersonationToken: string): void => {
  localStorage.setItem(originalTokenName, originalToken)
  localStorage.setItem(impersonationTokenName, impersonationToken)
  localStorage.setItem(tokenName, impersonationToken)
  isLoggedInVar(true)
}

export const quitImpersonationSession = (): void => {
  const originalToken = getOriginalToken()
  localStorage.removeItem(impersonationTokenName)
  localStorage.removeItem(originalTokenName)

  if (originalToken) {
    localStorage.setItem(tokenName, originalToken)
    isLoggedInVar(true)
    return
  }

  localStorage.removeItem(tokenName)
  isLoggedInVar(false)
}

export const removeToken = (): void => {
  localStorage.removeItem(tokenName)
  localStorage.removeItem(originalTokenName)
  localStorage.removeItem(impersonationTokenName)
  isLoggedInVar(false)
}

export const logout = <T>(client: ApolloClient<T>, force = false): void => {
  removePerformanceStatsFilters()
  removeToken()
  force ? client.cache.reset() : undefined
}
